import { useEffect } from 'react';
import {
  Link as ScrollToLink,
  animateScroll
} from "react-scroll";

const Talent = () => {
  useEffect( () => animateScroll.scrollToTop() )

  const imgStyle = {
    width: "100%",
    maxWidth: "150px",
    border: "solid rgba(246,61,3, 1)",
    borderRadius: "50%",
    backgroundColor: "rgba(71,75,81, 0.8)"
  }

  return (
    <div id="talent-content-wrapper">
      <ScrollToLink />
      <h1 className="major" id="talent">Talent</h1>
      <p>The talent behind Useful Coin is exceptional. Munair and Mason are two of the most compassionate and thoughtful geeks you'd ever want to collaborate with.</p>
      <span className="image">
        <a className="image dropshadow" href="https://www.linkedin.com/in/munair/">
          <img src="images/linkedin-usefulcoin-principal-advisor-350x350px-1.png" alt="munair" style={imgStyle} />
        </a>
      </span>
      <h3 className="major" id="munair">Munair Simpson</h3>
      <p>After completing his first token marketing campaign in Seoul, Korea in early 2017, <a href="https://www.linkedin.com/in/munair/" target="_blank" rel="noreferrer">Munair Simpson</a> established Useful Coin LLC to continue to help new ventures strategically develop tokens and delve deeper into the cryptocurrency world.</p>
      <p>Today, Munair is completely committed to researching and developing useful cryptocurrencies. In particular, he enjoys advising ventures that choose to finance their aspirations issuing fundamentally valuable tokens. Munair then introduces those coins to a network of cryptocurrency funds and private investors.</p>
      <p>Having the good fortune to research, develop, and implement strategies to successfully capitalize several new token-financed ventures, Munair now provides advisory services to clients around the globe, including South Korea, the Cayman Islands, Jamaica, and the United States of America.</p>
      <p>Munair graduated from the Wharton School at the University of Pennsylvania with an MBA in marketing. He also studied the analysis, design, and management of information systems at the University of California in Berkeley and received a bachelor of science in industrial engineering from the University of the West Indies in Trinidad and Tobago.</p>
      <p>When time permits, Munair enjoys contributing to <a href="http://coincentral.com/author/munair/"  target="_blank" rel="noreferrer">Coin Central</a> and the Expert Take at <a href="http://cointelegraph.com/authors/munair_simpson"  target="_blank" rel="noreferrer">Coin Telegraph</a>.</p>
      <span className="image">
        <a className="image dropshadow" href="https://www.linkedin.com/in/mason-eckenrod-6845291b4/"  target="_blank" rel="noreferrer">
          <img src="images/mason-350x350px.png" alt="mason" style={imgStyle} />
        </a>
      </span>
      <h3 className="major" id="mason">Mason Eckenrod</h3>
      <p>Mason is an aspiring computer scientist. He joined Useful Coin in April 2021, but is currently working on earning his Bachelor’s of Computer Science at the University of Texas in San Antonio. When time permits, he assits with the development of Useful Coin's proprietary trading systems and various other research and development initiatives.</p>
      <p>During his studies, Mason discovered cryptocurrencies and became completely enthralled with its allure of investing, trading, and decentralization. During his free time, Mason enjoys writing scripts and spending time with his weim reiner.</p>
    </div>
  );
}

export default Talent;
